import axios from "axios";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
export const portfolioBillingCsvURL = (params) => {
    const baseUrl = environment() === "PROD"
        ? "https://middleware.prod.farther.com/investment/portfolio-billing/versions"
        : "https://middleware.uat.farther.com/investment/portfolio-billing/versions";
    const versionUrl = `${baseUrl}/${params.versionId}`;
    if (params.reportType === undefined || params.reportType === "all") {
        return versionUrl;
    }
    const qs = new URLSearchParams();
    qs.append("reportType", params.reportType);
    return `${versionUrl}?${qs.toString()}`;
};
export const getPortfolioBillingCsv = async (params, config) => {
    try {
        const { data } = await axios.get(portfolioBillingCsvURL(params), {
            headers: {
                version: "20250610",
                Authorization: `Bearer ${config.jwt}`,
                Advisor: config.advisorId,
                Accept: "text/csv",
            },
            responseType: "text",
        });
        return data;
    }
    catch (error) {
        const errorMessage = `[getPortfolioBillingCsv.ts] failed to get billing CSV`;
        errorLog(errorMessage, error instanceof Error ? error.message : String(error));
        throw error;
    }
};
//# sourceMappingURL=getPortfolioBillingCsv.js.map